/**
 * Author List Load More Functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    const loadMoreBtns = document.querySelectorAll('.author-load-more-btn');
    
    loadMoreBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            const blockId = this.closest('.author-list-block').dataset.blockId;
            const currentPage = parseInt(this.dataset.currentPage);
            const totalAuthors = parseInt(this.dataset.totalAuthors);
            const authorsPerPage = parseInt(this.closest('.author-list-block').dataset.authorsPerPage);
            const nextPage = currentPage + 1;
            
            // Show loading state
            this.querySelector('.btn-text').style.display = 'none';
            this.querySelector('.btn-loading').style.display = 'inline-block';
            this.disabled = true;
            
            // Make AJAX request
            const formData = new FormData();
            formData.append('action', 'load_more_authors');
            formData.append('block_id', blockId);
            formData.append('page', nextPage);
            formData.append('authors_per_page', authorsPerPage);
            formData.append('nonce', authorListAjax.nonce);
            
            fetch(authorListAjax.ajaxurl, {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Append new authors to the list
                    const authorList = document.getElementById('author-list-' + blockId);
                    authorList.insertAdjacentHTML('beforeend', data.data.html);
                    
                    // Update button data
                    this.dataset.currentPage = nextPage;
                    const showing = Math.min(nextPage * authorsPerPage, totalAuthors);
                    
                    // Hide button if no more authors
                    if (showing >= totalAuthors) {
                        this.style.display = 'none';
                    }
                } else {
                    console.error('Error loading more authors:', data.data);
                    alert('Error loading more authors. Please try again.');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Error loading more authors. Please try again.');
            })
            .finally(() => {
                // Hide loading state
                this.querySelector('.btn-text').style.display = 'inline-block';
                this.querySelector('.btn-loading').style.display = 'none';
                this.disabled = false;
            });
        });
    });
});
